export enum Utils {
  // Requests headers
  InterceptorSkipHeader = 'XPO-Skip-Interceptor',
  // Formats
  dateFormatForRequests = 'YYYY-MM-DD',
  dateFormatForDisplay = 'MM/DD/YYYY',
  dateFormatForSingleMonth = 'M/DD/YYYY',
  dateFormatForMoment = 'MM-DD-YYYY',
  dateFormatWithTime = 'MM/DD/YYYY HH:mm z',
  pstTimeZone = 'America/Los_Angeles',
  // Common messages
  invalidCommentMessage = `Only alpha-numeric and the following special characters are allowed . , $ / + - & ( ) @ * % < > " : ! ? = '`,
  undefined = 'undefined',
  DefaultDate = '12-31-2999',
  uiPageSize = '5000',
  pageSize = 'PageSize',
  // Yes/No
  shortYes = 'Y',
  shortNo = 'N',
  Yes = 'YES',
  No = 'No',
  // ZIP CODE PATTERNS
  usCanadaZip = '^\\d{1,5}$|^[A-Za-z]\\d[A-Za-z]\\d[A-Za-z]\\d$|^[A-Za-z]\\d[A-Za-z]$',
  usZip = '^\\d{1,5}$',
  canadaZip = '^[A-Za-z]\\d[A-Za-z]\\d[A-Za-z]\\d$|^[A-Za-z]\\d[A-Za-z]$',
  // DECIMAL PATTERNS
  ruleRatePatternOptionalDecimals = '^[0](\\.\\d{0,4})?$',
}
